import { render, staticRenderFns } from "./MembroShow.vue?vue&type=template&id=512268cd&scoped=true&"
import script from "./MembroShow.vue?vue&type=script&lang=js&"
export * from "./MembroShow.vue?vue&type=script&lang=js&"
import style0 from "./MembroShow.vue?vue&type=style&index=0&id=512268cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512268cd",
  null
  
)

export default component.exports